@if (!NATIVE_DATEPICKER) {
  <div class="form-group label-static is-empty"
       [class]="{'is-focused': $any(input).isFocused, 'input--filled': !!formControl.value, 'has-error': !!errors() }">
    <label [htmlFor]="controlName()" class="control-label">
      {{ schemaTranslations()?.getFieldTranslation(controlName()) }}
      @if (properties().isFieldRequired(controlName())) {
        <span class="required">*</span>
      }
    </label>
    <input type="text"
           class="form-control"
           bsDatepicker
           #input="bsDatepicker"
           appFocusable
           (onFocusChange)="onFocusChange(input); $any(input).isFocused = $event;"
           [triggers]="''"
           [id]="controlName()"
           [autocomplete]="AUTOCOMPLETE[controlName()]"
           [required]="properties().isFieldRequired(controlName())"
           [formControl]="formControl"/>
  </div>
} @else {
  <div class="form-group label-static is-empty"
       [class]="{'is-focused': $any(input).isFocused, 'input--filled': !!formControl.value, 'has-error': !!errors() }">
    <label [htmlFor]="controlName()" class="control-label">
      {{ schemaTranslations()?.getFieldTranslation(controlName()) }}
      @if (properties().isFieldRequired(controlName())) {
        <span class="required">*</span>
      }
    </label>
    <input type="date"
           class="form-control"
           #input
           appFocusable
           (onFocusChange)="$any(input).isFocused = $event;"
           [id]="controlName()"
           [autocomplete]="AUTOCOMPLETE[controlName()]"
           [required]="properties().isFieldRequired(controlName())"
           [formControl]="formControl"/>
  </div>
}
